import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const AccountProfileFunctionality = { id: 17, name: 'Account Profile Functionality' };
export const accountAutocompleteEndpoint = defineFeature({
    type: FeatureType.Json,
    propName: 'account_autocomplete_endpoint',
    uiName: 'accountAutocompleteEndpoint',
    displayName: 'Account Autocomplete Endpoint',
    description: 'Configure the data connection and relative endpoint path used for account autocomplete lookups',
    category: AccountProfileFunctionality,
    areas: [],
    codec: 'identity',
    schema: z
        .object({
        connectionIdentifier: z.string().min(1),
        path: z.string().startsWith('/'),
    })
        .nullable(),
    default: null,
    isSystem: true,
    editor: 'data-connection-endpoint',
});
export const accountSearchEndpoint = defineFeature({
    type: FeatureType.Json,
    propName: 'account_search_endpoint',
    uiName: 'accountSearchEndpoint',
    displayName: 'Account Search Endpoint',
    description: 'Configure the data connection and relative endpoint path used for account search lookups',
    category: AccountProfileFunctionality,
    areas: [],
    codec: 'identity',
    schema: z
        .object({
        connectionIdentifier: z.string().min(1),
        path: z.string().startsWith('/'),
    })
        .nullable(),
    default: null,
    isSystem: true,
    editor: 'data-connection-endpoint',
});
export const viewAccountProfileTool = defineFeature({
    type: FeatureType.Boolean,
    propName: 'view_account_profile_tool',
    uiName: 'viewAccountProfileTool',
    displayName: 'View Account Profile Tool',
    description: 'Enable the tool that returns account profile details for the current context',
    category: AccountProfileFunctionality,
    areas: ['agent'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
    surfacedIn: ['agent'],
});
export const accountProfileFunctionalityFeatures = [
    accountAutocompleteEndpoint,
    accountSearchEndpoint,
    viewAccountProfileTool,
];
